<template>
  <div>
    <form
      v-for="element in socials"
      :key="element.name"
      method="POST"
      :action="element.href"
    >
      <button
        class="tw-flex tw-w-full tw-items-center tw-rounded-md tw-border tw-border-neutral-300 tw-px-4 tw-py-2 tw-shadow-sm tw-transition-colors hover:tw-border-neutral-200 hover:tw-bg-neutral-200 hover:tw-text-current"
        type="submit"
        :id="element.buttonId"
      >
        <component
          :is="element.icon"
          class="tw-mr-3 tw-h-6 tw-w-6 tw-grayscale"
        />

        <span class="tw-text-sm">{{ element.label }}</span>
      </button>
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
    </form>
  </div>
</template>

<script setup>
import FacebookIcon from '@/assets/images/facebook-logo.svg'
import GoogleIcon from '@/assets/images/google-logo.svg'
import LinkedInIcon from '@/assets/images/linkedin-logo.svg'
import { queryParameters } from '@/shared/utils/queryParameters.js'
import { onBeforeMount, onMounted, ref } from 'vue'

const csrfToken = ref(null)
const socials = [
  {
    name: 'Facebook',
    value: 'facebook',
    buttonId: 'social-media-login-button-facebook',
    label: 'Sign in with Facebook',
    icon: FacebookIcon,
    href: '/mentees/auth/facebook',
  },
  {
    name: 'Google',
    value: 'google',
    buttonId: 'social-media-login-button-google',
    label: 'Sign in with Google',
    icon: GoogleIcon,
    href: '/mentees/auth/google_oauth2',
  },
  {
    name: 'LinkedIn',
    value: 'linkedin',
    buttonId: 'social-media-login-button-linkedin',
    label: 'Sign in with LinkedIn',
    icon: LinkedInIcon,
    href: '/mentees/auth/linkedin',
  },
]

onBeforeMount(() => {
  csrfToken.value = document.querySelector('meta[name="csrf-token"]').content
})
onMounted(() => {
  const socialMediaLoginQueryParamValue =
    queryParameters().getParam('social-media-login')
  const socialMedia = socials.find(
    (social) => social.value === socialMediaLoginQueryParamValue,
  )
  if (!socialMedia) return
  const button = document.getElementById(socialMedia.buttonId)
  button.click()
})
</script>
